import { DestinationType, ProgressBarStep, ProductTypeHelper, SearchMaskInputType, websiteActions, ProductType, store } from 'ltur-state-engine';
import Vue from 'vue-ltur';
// import UrlHelper from "Helper/UrlHelper";
var urlHelperPromise = import("../../Helper/UrlHelper");
import { getFacetFromGroupResponse } from "Helper/State";
var productsPromise = import('../../Helper/Products');
import BodyScrollLock from 'static-components/src/body-scroll-lock';
import SeoContent from "Helper/SeoContent";
import { VariantsHelper } from "HotelDetails/VariantsHelper";
var FilterHelper = /** @class */ (function () {
    function FilterHelper() {
    }
    FilterHelper.dispatchToState = function (searchMaskInput, searchMaskGroupType) {
        var state = store.getState();
        var searchMaskRequest = {
            searchMaskGroupType: searchMaskGroupType,
            searchMaskInput: searchMaskInput,
            inputValueParam: searchMaskInput.confirmedValue
        };
        Vue.dispatch(websiteActions.setSearchMaskConfirmed(searchMaskRequest, state));
    };
    FilterHelper.dispatchPagination = function () {
        var state = store.getState();
        var pageProductType = ProductTypeHelper.mapToSearchMaskGroupType(state.websiteState.app.url.context.productType);
        var searchMaskGroup = state.websiteState.searchMask.searchMaskBundle.groups[pageProductType];
        var pagination = searchMaskGroup.inputs[SearchMaskInputType.PAGINATION].defaultValue.value;
        if (searchMaskGroup.inputs[SearchMaskInputType.PAGINATION].confirmedValue && searchMaskGroup.inputs[SearchMaskInputType.PAGINATION].confirmedValue.value) {
            pagination.sorting = searchMaskGroup.inputs[SearchMaskInputType.PAGINATION].confirmedValue.value.sorting;
        }
        pagination.page = 0;
        Vue.dispatch(websiteActions.setPagination(pagination, pageProductType));
    };
    FilterHelper.applyFilter = function (lturState) {
        FilterHelper.fetchFromCoreForResultLists(lturState);
        urlHelperPromise.then(function (module) {
            SeoContent.removeSeoContent();
            module.default.updateBrowserUrl(lturState, false, true);
        });
    };
    FilterHelper.applyFilterForHotelDetails = function (lturState, flushVariants) {
        if (flushVariants === void 0) { flushVariants = false; }
        if (flushVariants)
            VariantsHelper.instance.flushMap();
        FilterHelper.fetchFromCoreForHotelDetails(lturState);
        FilterHelper.getVariants();
        urlHelperPromise.then(function (module) {
            module.default.updateBrowserUrl(lturState, true, false, false);
        });
    };
    FilterHelper.applyFilterForHotelDetailsAndIgnoreVariants = function (lturState) {
        FilterHelper.fetchFromCoreForHotelDetails(lturState);
        urlHelperPromise.then(function (module) {
            module.default.updateBrowserUrl(lturState, true, false, false);
        });
    };
    FilterHelper.isAutoApplyActive = function () {
        var isMobile = (768 > (window.innerWidth || document.documentElement.clientWidth));
        return !isMobile;
    };
    FilterHelper.toggleFilterbar = function () {
        var flyoutFilterbar = document.getElementById('flyoutFilterbar');
        flyoutFilterbar.classList.toggle('is-toggled');
        document.querySelector('.js-header').classList.toggle('u-hide@mobile');
        BodyScrollLock.toggleBodyScrollPosition();
    };
    FilterHelper.getFacetValue = function (lturState, optionId) {
        var destinationType = FilterHelper.extractDestinationType(lturState);
        var facet = getFacetFromGroupResponse(destinationType, optionId);
        if (facet) {
            return facet.value;
        }
        else {
            return null;
        }
    };
    FilterHelper.fetchFromCoreForResultLists = function (lturState) {
        var destinationType = FilterHelper.extractDestinationType(lturState);
        FilterHelper.getProducts(destinationType);
    };
    FilterHelper.fetchFromCoreForHotelDetails = function (lturState) {
        var productType = lturState.websiteState.app.url.context.productType;
        switch (productType) {
            case ProductType.HOTEL:
                FilterHelper.getOffers();
                break;
            default:
                FilterHelper.getFlightAlternativesForPackage();
        }
    };
    FilterHelper.extractDestinationType = function (lturState) {
        var currentStep = lturState.websiteState.app.currentStep;
        switch (currentStep) {
            case ProgressBarStep.DESTINATION: {
                return DestinationType.DESTINATION;
                break;
            }
            case ProgressBarStep.HOTEL_LIST: {
                return DestinationType.HOTEL_LIST;
                break;
            }
            default: {
                return DestinationType.HOTEL_LIST;
            }
        }
    };
    FilterHelper.getProducts = function (destinationType) {
        productsPromise.then(function (moduleProducts) {
            moduleProducts.default.getGroupsAsync(destinationType);
            if (destinationType === DestinationType.HOTEL_LIST) {
                moduleProducts.default.getProductsAsync(destinationType);
                moduleProducts.default.getSuggestionsAsync();
            }
        });
    };
    FilterHelper.getFlightAlternativesForPackage = function () {
        productsPromise.then(function (moduleProducts) {
            moduleProducts.default.getPackageFlightAlternativesAsync();
        });
    };
    FilterHelper.getOffers = function () {
        productsPromise.then(function (moduleProducts) {
            moduleProducts.default.getOffersAsync();
        });
    };
    FilterHelper.getVariants = function () {
        productsPromise.then(function (moduleProducts) {
            moduleProducts.default.getVariantsAsync();
        });
    };
    return FilterHelper;
}());
export default FilterHelper;
